module.exports = __webpack_public_path__ + "static/media/dentistry.a91a8982.png";